const Links = {
	STREAM_STICKERS_HOME: 'https://www.streamstickers.com',
};

const StickerType = {
	CUSTOM: 'CUSTOM',
	REWARD: 'REWARD',
	POWER: 'POWER',
	TTS: 'TTS',
	GLOBAL: 'GLOBAL',
};

const TtsDisplayMode = {
	STICKER: 'STICKER',
	CO_HOST: 'CO_HOST',
};

module.exports = { Links, StickerType, TtsDisplayMode };
